import Errored from '../Errored';
import Notification from '../../core/Notification';
import BasicReadField from '../../core/BasicReadField';
import ErrorIcon from '@material-ui/icons/Error';
import DoneIcon from '@material-ui/icons/Done';
import PrimaryButton from '../PrimaryButton';
import Loading from '../../core/Loading';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeCancelable, displayDate, displayUser } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import MenuSelector from '../MenuSelector';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreIcon from '@material-ui/icons/Restore';
import PropTypes from 'prop-types';
import React from 'react';
import AreYouSure from '../../core/AreYouSure';
import { globalStyles as styles } from '../../core/style/gstheme';
import TitledPanel from '../../core/TitledPanel';
import { getGraphFromProject, } from '../utils/utils';
import ViewOnly from '../ViewOnly';
import withGS from '../withGShoc';
import TakeSnapshotDialog from './TakeSnapshotDialog';

const periodOptions = [
    {
        "value": "60",
        "label": "1 Hour"
    },
    {
        "value": "720",
        "label": "12 Hours"
    },
    {
        "value": "1440",
        "label": "1 Day"
    }
];

const countOptions = [
    {
        "value": "5",
        "label": "5"
    },
    {
        "value": "10",
        "label": "10"
    },
    {
        "value": "25",
        "label": "25"
    },
    {
        "value": "50",
        "label": "50"
    },
    {
        "value": "100",
        "label": "100"
    }
];

class SnapshotConfigurationDetail extends React.Component {

    constructor(props) {
        super(props);
        const period = props.configuration.snapshotPeriod ?
            (props.configuration.snapshotPeriod / 60000).toString()
            :
            "60";
        const snapshotCount = props.configuration.snapshotCount ?
            props.configuration.snapshotCount.toString()
            :
            "5";
        this.state = {
            areYouSure: false,
            areYouSureRestore: false,
            getSnapshotInfo: false,
            recover: false,
            period,
            lastSnapshot: 0,
            snapshotCount,
            originalSnapshotCount: snapshotCount,
            originalPeriod: period,
            isLoadingSnapshots: true
        };
        this.cancellable = null;
        // Ideally get rid of this statement and be explicit on graph every time
    }

    componentDidMount() {
        this.loadSnapshots();
    }

    loadSnapshots = async () => {
        try {
            GS.handle("load-snapshots");
            const data = await this.doSearch({
                search: [
                    {
                        predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                        value: "https://grafsync.graphifi.com/schema/gs/Snapshot"
                    },
                    {
                        predicate: "https://grafsync.graphifi.com/schema/gs/snapshotConfiguration",
                        value: this.props.configuration.id
                    }
                ],
                graph: [GS.getActiveSubscription()],
                page: 1,
                noCount: true,
                pageSize: 200
            }).promise;
            let snapshots = [...data.results];
            this.sortSnapshots(snapshots);
            let lastSnapshot = 0;
            if (snapshots.length > 0) {
                lastSnapshot = snapshots[0].snapshotTime;
            }
            this.setState({ snapshots, isLoadingSnapshots: false, lastSnapshot });
        }
        catch (e) {
            if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) this.setState({ isErrored: e });
        }
    };

    sortSnapshots(snapshots) {
        return snapshots.sort(function (a, b) {
            if (a.snapshotTime > b.snapshotTime) return -1;
            if (a.snapshotTime < b.snapshotTime) return 1;
            return 0;
        });
    }

    doSearch(payload) {
        this.cancellable = makeCancelable(GS.search(payload));
        return this.cancellable;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    checkIfSure = () => this.setState({ areYouSure: true });

    onSure = () => {
        this.setState({ areYouSure: false });
        this.props.onDeleteConfiguration(this.props.configuration.id);
    };

    onNotSure = () => this.setState({ areYouSure: false, areYouSureRestore: false });

    handlePeriodChange = (period) => this.setState({ period }, this.checkIfDirty);

    handleCountChange = (snapshotCount) => this.setState({ snapshotCount }, this.checkIfDirty);

    saveUpdates = () => {
        this.props.onUpdateConfiguration(this.props.configuration.id, parseInt(this.state.period) * 60000, parseInt(this.state.snapshotCount));
        this.setState({
            isDirty: false,
            originalPeriod: this.state.period,
            originalSnapshotCount: this.state.snapshotCount
        });
    };

    checkIfDirty = () => {
        let isDirty = false;
        if (this.state.snapshotCount !== this.state.originalSnapshotCount
            || this.state.period !== this.state.originalPeriod) isDirty = true;
        this.setState({ isDirty });
    };

    takeSnapshot = () => {
        this.setState({ getSnapshotInfo: true });
    };

    executeSnapshot = (data) => {
        this.props.onTakeSnapshot(this.props.configuration.id, data);
    };

    restore = (snapshot, snapshotTime) => this.setState({ restore: snapshot, snapshotTime, areYouSureRestore: true });

    onRestoreSure = () => {
        this.setState({ areYouSureRestore: false });
        this.props.onRestoreData(this.props.data.id, this.props.configuration.projectType, getGraphFromProject(this.props.data.id), this.state.restore);
    };

    render() {

        const { classes, data, configuration, isReadOnly, users, graph } = this.props;
        const { areYouSure, period, snapshotCount, snapshots, isLoadingSnapshots, isErrored,
            isDirty, areYouSureRestore, snapshotTime, lastSnapshot } = this.state;
        const unavailable = data._notAvailable;
        const currentTime = Date.now();
        const graphLocked = GS.isGraphLocked(graph);

        if (isErrored) return <Errored dataTest="sd-error" data={isErrored} />;

        const isDeleted = data.pendingDeletion || !data || !data.title;
        const title = data && data.title ?
            data.title[data.defaultLang]
            :
            configuration.title ?
                configuration.title[Object.keys(configuration.title)[0]]
                :
                'Title not available';
        const defaultLang = data && data.defaultLang ?
            data.defaultLang
            :
            configuration.title ?
                Object.keys(configuration.title)[0]
                :
                '';

        return (
            <div>
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <div style={{ display: 'flex' }}>
                        <Avatar
                            data-test="avatar-language"
                            className={defaultLang.length > 2 ? classes.widePrimaryAvatar : classes.primaryAvatar}>
                            {defaultLang}
                        </Avatar>
                        <Typography
                            data-test="project-title"
                            style={{ marginLeft: '10px', marginTop: '3px' }}
                            className={classes.mainHeading}>
                            {title}
                            {isReadOnly && <ViewOnly />}
                        </Typography>
                    </div>
                    {!isReadOnly && !unavailable && !graphLocked &&
                        <Tooltip title='Delete snapshot setup' style={{ alignSelf: 'flex-end', marginTop: '5px' }}>
                            <IconButton data-test="delete-project" size="small" onClick={this.checkIfSure} className={classes.deleteButton}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    }
                </div>
                <Grid container spacing={2}>
                    {graphLocked &&
                        <Grid item xs={12}>
                            <Notification error={true} text="This project is currently locked." dataTest="locked" />
                        </Grid>
                    }
                    {data.pendingDeletion &&
                        <Grid item xs={12}>
                            <Notification error={true} text="This project is pending deletion." dataTest="pending-deletion" />
                        </Grid>
                    }
                    {unavailable &&
                        <Grid item xs={12}>
                            <Notification error={false} text="This project has either been permanently deleted or you do not have permissions to view the detail. The project title at the time of adding this project is being displayed." dataTest="permanently-deleted" />
                        </Grid>
                    }
                    <Grid item xs={12} md={4}>
                        <TitledPanel dataTest="project-type" title="Project Type" height="full">
                            <BasicReadField
                                ariaLabel="Project type"
                                dataTest="iri"
                                fullWidth
                                text={
                                    configuration.projectType === "https://grafsync.graphifi.com/schema/gs/OntologyProject" ?
                                        "Ontology"
                                        :
                                        configuration.projectType === "https://grafsync.graphifi.com/schema/gs/DataProject" ?
                                            "Data"
                                            :
                                            "Vocabulary"} />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TitledPanel dataTest="snapshot-period" title="Snapshot Period" height="full">
                            <MenuSelector
                                disabled={isReadOnly || data.pendingDeletion || unavailable || graphLocked}
                                dataTest="period-selector"
                                handleChange={this.handlePeriodChange}
                                selected={period}
                                hintWord="period"
                                options={periodOptions} />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TitledPanel dataTest="snapshot-max-count" title="Maximum Number of Snapshots" height="full">
                            <MenuSelector
                                disabled={isReadOnly || data.pendingDeletion || unavailable || graphLocked}
                                dataTest="snapshot-count-selector"
                                handleChange={this.handleCountChange}
                                selected={snapshotCount}
                                hintWord="value"
                                options={countOptions} />
                        </TitledPanel>
                    </Grid>
                    {!isReadOnly && !isDeleted && !unavailable && !graphLocked &&
                        <Grid item xs={12}>
                            <div style={{ float: 'right' }}>
                                <PrimaryButton dataTest="save" disabled={!isDirty} onClick={this.saveUpdates}>Save</PrimaryButton>
                            </div>
                        </Grid>
                    }
                    <Grid item xs={12}>
                        {isLoadingSnapshots ?
                            <Loading />
                            :
                            <TitledPanel dataTest="snapshots" title="Snapshots" height="full"
                                actions={
                                    !isReadOnly && !isDeleted && !unavailable && !graphLocked && lastSnapshot < currentTime - parseInt(process.env.REACT_APP_SNAPSHOT_DELAY) ?
                                        <div style={{ marginTop: 4 }}>
                                            <TakeSnapshotDialog onTakeSnapshot={this.executeSnapshot} />
                                        </div>
                                        :
                                        null
                                }>
                                {snapshots.length >= snapshotCount &&
                                    <div style={{ marginTop: 4 }}>
                                        <Notification error={false} text="As there are already the maximum number of snapshots, taking a snapshot will remove the earliest stored snapshot." dataTest="max-warning" />
                                    </div>
                                }
                                <div style={{ backgroundColor: '#ffffff', padding: 8, marginTop: 6 }}>
                                    <Table data-test="snapshot-viewer" style={{ maxWidth: '100%' }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell component="th" className={classes.tableHeading}>Status</TableCell>
                                                <TableCell component="th" className={classes.tableHeading}>Time</TableCell>
                                                <TableCell component="th" className={classes.tableHeading}>User</TableCell>
                                                <TableCell component="th" className={classes.tableHeading}>Version</TableCell>
                                                <TableCell component="th" className={classes.tableHeading}>Name</TableCell>
                                                <TableCell component="th" className={classes.tableHeading}>Comment</TableCell>
                                                <TableCell component="th" className={classes.tableHeading}>Identifier</TableCell>
                                                <TableCell component="th" className={classes.tableHeading}></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {snapshots.slice(0, snapshotCount).map((item, rowIndex) => {
                                                const failed = item.status && item.status[0] === "https://grafsync.graphifi.com/schema/gs/failed";
                                                const row = [
                                                    failed ?
                                                        <Tooltip title="Snapshot failed">
                                                            <ErrorIcon />
                                                        </Tooltip>
                                                        :
                                                        <DoneIcon />,
                                                    displayDate(item.snapshotTime, true),
                                                    item.snapshotUser ? displayUser(users, item.snapshotUser) : "",
                                                    item.isVersion === true ? "Yes" : "No",
                                                    item.snapshotName,
                                                    item.snapshotComment,
                                                    item.id.substring(44)
                                                ];
                                                return (
                                                    <TableRow key={"row-" + rowIndex} classes={{
                                                        root: classes.stripedRow
                                                    }}>
                                                        {row.map((cell, cellIndex) => {
                                                            const spans = [cell];
                                                            return <TableCell
                                                                key={cellIndex}
                                                                className={classes.tableCell}
                                                                style={{
                                                                    verticalAlign: 'middle'
                                                                }}>
                                                                <Typography className={classes.tableCellText}>
                                                                    {
                                                                        spans.map((spanText, spanIndex) => <span className={classes.tableCellLine} key={spanIndex}>{spanText}</span>)
                                                                    }
                                                                </Typography>
                                                            </TableCell>;
                                                        }
                                                        )}
                                                        {!isReadOnly && !graphLocked &&
                                                            <TableCell className={classes.tableCell} align="right">
                                                                {!failed &&
                                                                    <Tooltip title={"Restore project from " + row[1]}>
                                                                        <IconButton data-test="restore" size="small" onClick={() => this.restore(item.id, row[1])}>
                                                                            <RestoreIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                }
                                                            </TableCell>
                                                        }
                                                    </TableRow>
                                                );
                                            }
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            </TitledPanel>
                        }
                    </Grid>
                </Grid>
                {areYouSure && <AreYouSure onSure={this.onSure} onNotSure={this.onNotSure} message={
                    [
                        "Do you really want to delete this snapshot setup?",
                        "If you do then all snapshots will be removed and you will not be able to recover this project.",
                        "This action cannot be udone."
                    ]} />}
                {areYouSureRestore && <AreYouSure onSure={this.onRestoreSure} onNotSure={this.onNotSure} message={
                    [
                        snapshotTime,
                        "Do you really want to restore this snapshot?",
                        "If you do the current data for the project will be replaced.",
                        "This action cannot be undone."
                    ]} />}
            </div>
        );
    }
}

SnapshotConfigurationDetail.propTypes = {
    classes: PropTypes.object,
    configuration: PropTypes.object.isRequired,
    onDeleteConfiguration: PropTypes.func.isRequired,
    onUpdateConfiguration: PropTypes.func.isRequired,
    onTakeSnapshot: PropTypes.func.isRequired,
    onRestoreData: PropTypes.func.isRequired,
    isReadOnly: PropTypes.bool,
    users: PropTypes.array,
    id: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(SnapshotConfigurationDetail));